
window.addEventListener('DOMContentLoaded', function() {

  console.log('custom.js');
    /* 手机端点击左上角菜单，则显示货币切换BAR */
    $('body').on('click', '#DrawerMenuToggler', function() {
        console.log('111');
        if($(this).attr('data-aria-expanded') == 'true'){
            $('.ymq-currency-float-m.ymq-currency-l-b').show();
        }else{
            $('.ymq-currency-float-m.ymq-currency-l-b').hide();
        }
    });

});
